















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import FormItem from './FormItem.vue';
import PageFooter from '@/components/utils/PageFooter.vue';

@Component({
  components: {
    FormItem,
    PageFooter,
  },
})
export default class FormGroup extends Vue {
  maxItemByPage: number = 4;

  currentPageIndex: number = 0;

  @Prop({ type: Array, required: true })
  readonly items!: Array<any>;

  @Prop({ type: Number, required: true })
  readonly sort!: number;

  get compFormItem(): Array<Object> {
    return this.items
      .sort((firstForm: any, secondForm: any) => {
        const firstFormCreatedDate = new Date(firstForm.created_at).getTime();
        const secondFormCreatedDate = new Date(secondForm.created_at).getTime();
        if (this.sort === 1) {
          return secondFormCreatedDate - firstFormCreatedDate;
        }
        if (this.sort === -1) {
          return firstFormCreatedDate - secondFormCreatedDate;
        }
        return firstForm.id - secondForm.id;
      })
      .slice(this.currentPageIndex * this.maxItemByPage, this.maxItemByPage * (this.currentPageIndex + 1));
  }

  get compCountPage(): number {
    return Math.ceil(this.items.length / this.maxItemByPage);
  }

  @Watch('sort')
  onSortChange(): void {
    this.currentPageIndex = 0;
  }

  leftArrowClicked(): void {
    if (this.currentPageIndex !== 0) {
      this.currentPageIndex -= 1;
    }
  }

  rightArrowClicked(): void {
    if (this.currentPageIndex !== this.compCountPage - 1) {
      this.currentPageIndex += 1;
    }
  }

  pageNumberclicked(page: number): void {
    this.currentPageIndex = page - 1;
  }
}
